import { Button as AntButton, ButtonProps, Row } from "antd";
import React, { CSSProperties, JSX } from "react";
import styled, { css } from "styled-components";
import color from "../../resource/color";
import Text, { TextType } from "../Text/Text";

type TypeButton =
  | "primary"
  | "secondary"
  | "danger"
  | "default"
  | "primary-light"
  | "border-light"
  | "disabled"
  | "success"
  | "border-danger"
  | "navy-blue"
  | "black"
  | "approve"
  | "light-navy-blue"
  | "light-disabled"
  | "border-primary"
  | "light-dashed"
  | "light-navy-blue"
  | "border-dashed-primary"
  | "border-dashed-disabled";
interface StyledButton {
  $typeButton?: TypeButton;
  height?: number;
}
const ButtonStyled = styled(AntButton)<StyledButton>`
  height: ${(props) => props.height || 40}px;

  width: 100%;
  padding: 8px 16px;
  justify-content: center;
  display: flex;
  align-items: center;
  ${({ $typeButton }) => {
    if ($typeButton === "secondary") {
      return css`
        background-color: ${color.background1} !important;
        color: white;
        border: 1px solid ${color.background1} !important;
      `;
    }
    if ($typeButton === "danger") {
      return css`
        background-color: ${color.error} !important;
        color: white;
        border: 1px solid ${color.error} !important;
        .anticon {
          color: white;
        }
      `;
    }
    if ($typeButton === "border-danger") {
      return css`
        background-color: ${color.white} !important;
        color: ${color.primary} !important;
        border: 1px solid ${color.error} !important;
      `;
    }
    if ($typeButton === "navy-blue") {
      return css`
        background-color: ${color.secondary} !important;
        color: ${color.secondary} !important;
        border: 1px solid ${color.secondary} !important;
      `;
    }
    if ($typeButton === "primary-light") {
      return css`
        background-color: ${color.white} !important;
        color: ${color.primary} !important;
        border: 1px solid ${color.primary} !important;
      `;
    }
    if ($typeButton === "border-light") {
      return css`
        background-color: transparent !important;
        border: 1px solid ${color.background2} !important;
      `;
    }
    if ($typeButton === "light-dashed") {
      return css`
        background-color: transparent !important;
        border: 1px dashed ${color.primary} !important;
      `;
    }
    if ($typeButton === "disabled") {
      return css`
        background-color: ${color.placeholder} !important;
        border: 1px solid ${color.Disable} !important;
      `;
    }
    if ($typeButton === "success") {
      return css`
        background-color: ${color.success} !important;
        color: white;
        border: 1px solid ${color.success} !important;
      `;
    }
    if ($typeButton === "black") {
      return css`
        background-color: ${color.black} !important;
        color: white;
        border: 1px solid ${color.black} !important;
      `;
    }
    if ($typeButton === "light-navy-blue") {
      return css`
        background-color: ${color.white} !important;
        color: ${color.secondary} !important;
        border: 1px solid ${color.secondary} !important;
      `;
    }
    if ($typeButton === "light-disabled") {
      return css`
        color: ${color.background4} !important;
        background-color: ${color.white} !important;
        border: 1px solid ${color.white} !important;
      `;
    }
    if ($typeButton === "approve") {
      return css`
        color: ${color.warning} !important;
        background-color: ${color.warning} !important;
        border: 1px solid ${color.white} !important;
      `;
    }
    if ($typeButton === "border-primary") {
      return css`
        background-color: ${color.white} !important;
        color: ${color.primary} !important;
        border: 1px solid ${color.primary} !important;
      `;
    }
    if ($typeButton === "border-dashed-primary") {
      return css`
        background-color: ${color.white} !important;
        color: ${color.primary} !important;
        border: 1px dashed ${color.primary} !important;
      `;
    }
    if ($typeButton === "border-dashed-disabled") {
      return css`
        background-color: ${color.white} !important;
        color: ${color.background4} !important;
        border: 1px dashed ${color.background4} !important;
      `;
    }
    return css`
      background-color: ${color.primary} !important;
      color: white;
      border: 1px solid ${color.primary} !important;
    `;
  }}
`;
interface Props extends ButtonProps, StyledButton {
  title?: any;
  typeButton?: TypeButton;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  textStyle?: TextType;
  iconPlacement?: "left" | "right";
}
export default function Button({
  title,
  typeButton = "primary",
  icon,
  iconRight,
  textStyle,
  iconPlacement = "left",
  ...props
}: Props): JSX.Element {
  return (
    <ButtonStyled {...props} $typeButton={typeButton}>
      <Row
        style={{
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          gap: 6,
        }}
      >
        {iconPlacement === "left" && <>{icon && icon}</>}
        {title && (
          <Text
            level={props.level || 5}
            color={
              typeButton === "light-dashed"
                ? "primary"
                : typeButton === "border-danger"
                  ? "error"
                  : typeButton === "primary"
                    ? "white"
                    : typeButton === "approve"
                      ? "white"
                      : typeButton === "primary-light" || typeButton === "border-dashed-primary"
                        ? "primary"
                        : typeButton === "border-primary"
                          ? "primary"
                          : typeButton === "disabled" ||
                              typeButton === "danger" ||
                              typeButton === "success" ||
                              typeButton === "black" ||
                              typeButton === "navy-blue"
                            ? "white"
                            : typeButton === "light-disabled" ||
                                typeButton === "border-dashed-disabled"
                              ? "background4"
                              : "Text1"
            }
            {...textStyle}
          >
            {title}
          </Text>
        )}
        {iconPlacement === "right" && <>{icon && icon}</>}
        {iconRight && <>{iconRight}</>}
      </Row>
    </ButtonStyled>
  );
}
